<template>
  <div class="guide-container">
    <div class="step-box">
      <div class="menu-bg">
        <img
          src="./../../../img/guide-img.png"
          alt="新手引导"
        />
      </div>
      <div class="tip-content">
        <p class="content-text">
          新增“多品类套装申请”,快来试试吧！
        </p>
        <div class="content-button">
          <button @click="$emit('close')">
            知道了
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ComerGuide',
  created() {
    document.body.style.overflow = 'hidden'
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto'
  }
}
</script>
<style lang="scss" scoped>
.guide-container {
  background-color: transparent;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  background: rgba(0,0,0,0.1);
  .step-box {
    position: absolute;
    left: 12px;
    top: 165px;
    width: 176px;
    height: 40px;
    background: #fff;
    border-radius: 12px;
    .menu-bg {
      width: 176px;
      height: 40px;
      border-radius: 12px;
      animation: animated-border 0.4s linear normal forwards;
      > img {
        width: 100%;
        height: 100%;
        border-radius: 12px;
      }
    }
    .tip-content {
      position: absolute;
      top: 0;
      left: 198px;
      padding: 16px;
      width: 192px;
      height: 112px;
      background-color: #1261ff;
      border-radius: 4px;
      box-shadow: 0px 9px 28px 8px rgba(0,0,0,0.05), 0px 6px 16px 0px rgba(0,0,0,0.08), 0px 3px 6px -4px rgba(0,0,0,0.12);
      color: #fff;
      &:before {
        content: "";
        position: absolute;
        top: 20px;
        left: -12px;
        border: 6px solid transparent;
        border-right-color: #1261ff;
        transform: translate(0, -50%);
      }
      .content-text {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        word-break: break-all;
      }
      .content-button {
        width: 100%;
        text-align: right;
        > button {
          margin-top: 12px;
          width: 60px;
          height: 28px;
          background-color: #fff;
          border-radius: 4px;
          font-size: 12px;
          color: #1261ff;
          &:hover {
            background-color: rgba(255,255,255,0.8);
          }
        }
      }
    }
  }
}
@keyframes animated-border {
  0% {
    box-shadow: none;
  }
  100% {
    box-shadow: 0px 0px 20px 0px rgba(18,97,255,0.2);
  }
}
</style>
